// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    getAutoDeliveryCollection as getAutoDeliveryCollectionService,
    GetAutoDeliveryCollectionApiParameter,
} from "@guestsupply/App/Services/AutoDelivery";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";

type HandlerType = ApiHandler<GetAutoDeliveryCollectionApiParameter, any>;

export const DispatchBeginLoadAutoDeliveryOrders: HandlerType = props => {
    props.dispatch({
        type: "xAutoDelivery/BeginLoadOrders",
        parameter: props.parameter,
    } as any);
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getAutoDeliveryCollectionService(props.apiParameter);
};

export const DispatchCompleteLoadAutoDeliveryOrders: HandlerType = props => {
    if (props.apiResult.successful) {
        props.dispatch({
            type: "xAutoDelivery/CompleteLoadOrders",
            parameter: props.parameter,
            collection: props.apiResult.result,
        } as any);
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        props.dispatch({
            type: "xAutoDelivery/CompleteLoadOrders",
            parameter: {},
            collection: [],
        } as any);
    }
};

export const chain = [
    PopulateApiParameter,
    DispatchBeginLoadAutoDeliveryOrders,
    RequestDataFromApi,
    DispatchCompleteLoadAutoDeliveryOrders,
    ExecuteOnErrorCallback,
];

const loadAutoDeliveryOrders = createHandlerChainRunner(chain, "getAutoDeliveryCollection");
export default loadAutoDeliveryOrders;
